module.exports = __webpack_public_path__ + "img/symbol_7.b10be2e1.png";